import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {useAbility} from '@casl/react';
import {useIntl} from 'react-intl';

import {Menu} from 'antd';
import routesConfig from 'pages/routeConfig';
import {useSidebarContext} from './AppContextProvider/SidebarContextProvider';
import {AbilityContext} from 'configs/CASLContext';
import {isPermit} from 'utils/AuthUtils';

function getStyles(item, sidebarColorSet, index) {
  const {pathname} = useLocation();
  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split('/');

  const isOpen = defaultOpenKeys[index] === item.id;
  return {
    color: isOpen
      ? sidebarColorSet.sidebarMenuSelectedTextColor
      : sidebarColorSet.sidebarTextColor,
    backgroundColor: isOpen
      ? sidebarColorSet.sidebarMenuSelectedBgColor
      : sidebarColorSet.sidebarBgColor,
  };
}

const renderMenuItemChildren = (ability, item) => {
  const {icon, messageId, path} = item;
  const {messages} = useIntl();

  if (isPermit(ability, item.authorities)) {
    if (path && path.includes('/'))
      return (
        <Link to={path}>
          {icon &&
            (React.isValidElement(icon) ? (
              <span className='ant-menu-item-icon'>{icon}</span>
            ) : (
              <icon className='ant-menu-item-icon' />
            ))}
          <span data-testid={messageId.toLowerCase + '-nav'}>
            {messages[messageId]}
          </span>
        </Link>
      );
    else {
      return (
        <>
          {icon &&
            (React.isValidElement(icon) ? (
              <span className='ant-menu-item-icon'>{icon}</span>
            ) : (
              <icon className='ant-menu-item-icon' />
            ))}
          <span data-testid={messageId.toLowerCase + '-nav'}>
            {messages[messageId]}
          </span>
        </>
      );
    }
  }
};

const renderMenuItem = (ability, item, sidebarColorSet, index) => {
  return (
    isPermit(ability, item.authorities) &&
    (item.type === 'collapse' ? (
      <Menu.SubMenu
        style={getStyles(item, sidebarColorSet, index, true)}
        key={item.path ? item.path : item.id}
        title={renderMenuItemChildren(ability, item, sidebarColorSet)}>
        {item.children.map((item) =>
          renderMenuItem(ability, item, sidebarColorSet, index + 1),
        )}
      </Menu.SubMenu>
    ) : (
      <Menu.Item key={item.id} style={getStyles(item, sidebarColorSet, index)}>
        {item.children
          ? item.children
          : renderMenuItemChildren(ability, item, sidebarColorSet)}
      </Menu.Item>
    ))
  );
};

const renderHorMenu = (ability, item, sidebarColorSet, index) => {
  return (
    isPermit(ability, item.authorities) &&
    (item.type === 'group' ? (
      <Menu.SubMenu
        style={getStyles(item, sidebarColorSet, index, true)}
        key={item.path ? item.path : item.id}
        title={renderMenuItemChildren(ability, item, sidebarColorSet)}>
        {item.children.map((item) =>
          renderMenuItem(ability, item, sidebarColorSet, index + 1),
        )}
      </Menu.SubMenu>
    ) : (
      <Menu.Item
        key={item.id}
        exact={item.exact}
        style={getStyles(item, sidebarColorSet, index, true)}>
        {item.children
          ? item.children
          : renderMenuItemChildren(ability, item, sidebarColorSet)}
      </Menu.Item>
    ))
  );
};

export const getRouteHorMenus = () => {
  const {sidebarColorSet} = useSidebarContext();
  const ability = useAbility(AbilityContext);

  return routesConfig.map((route) =>
    renderHorMenu(ability, route, sidebarColorSet, 0),
  );
};
